/**** mgt."Validator" */
import { apiTypes } from 'shared/consts/handbooksApiTypes';

const config = {
  schema: 'mgt',
  table: 'Validator',
  title: 'Устройства контроля оплаты',
  apiType: apiTypes.DEFAULT,
  elemsOnPage: 100,
  connections: {
    vehicle: {
      apiType: apiTypes.DEFAULT,
      schema: 'mgt',
      table: 'Vehicle',
      index: 'vehicle_id',
      fields: ['depot_number'],
      format: (elem: any) => elem['depot_number'],
      autocomplete: true,
    }
  },
  fields: [
    {
      name: 'validator_id',
      title: 'ID валидатора',
      index: true,
      edited: true,
      required: true,
      type: 'number',
      width: '120px',
    },
    {
      name: 'validator_name',
      title: 'Название валидатора',
      type: 'text',
      required: false,
    },
    {
      name: 'vehicle_id',
      title: 'Транспортное средство',
      type: 'number',
      required: true,
      connection: 'vehicle'
    }
  ],
  newTemplate: {
    validator_id: null,
    validator_name: '',
    vehicle_id: null
  },
  createField: 'createdAt',
  updateField: 'updatedAt',
  defaultSort: {
    field: 'validator_id',
    direction: 'asc',
  },
  import: {
    header: [
      {
        title: 'validator_id',
        field: 'validator_id',
      },{
        title: 'validator_name',
        field: 'validator_name',
      },
      {
        title: 'vehicle_id',
        field: 'vehicle_id',
      }
    ],
    example: `1;Название;1`,
  },
};

export default config;
